import overviewController from './overview/overview.controller'
import overviewTemplate from './overview/overview.html'
import './overview/overview.scss'

import detailsController from './details/details.controller'
import detailsTemplate from './details/details.html'
import './details/details.scss'

let module = angular.module('invoices', [
	'ionic'
])
.config(($stateProvider) => {
	"ngInject";

	$stateProvider
		.state('tab.invoices', {
			url: '/invoices',
			views: {
				'tab-invoices': {
					template: overviewTemplate,
					controller: overviewController,
					controllerAs: 'overview'
				}
			}
		})
		.state('tab.details', {
			url: '/invoice?:id',
			views: {
				'tab-invoices': {
					template: detailsTemplate,
					controller: detailsController,
					controllerAs: 'details'
				}
			}
		})
		
})
.name;

export default module;


// WEBPACK FOOTER //
// ./app/components/invoices/invoices.js